module.exports = __webpack_public_path__ + "img/logo.8aae03fe.png";